import { useContext } from 'react';
import { Stack, Text } from '@ltvco/refresh-lib/theme';
import { AppConstants } from '@ltvco/refresh-lib/ctx';
import { SidebarCard } from '../components';

export const TrustBadges = () => {
  const { images } = useContext(AppConstants);
  const extendedImages = images as any;

  return (
    <>
      <SidebarCard>
        <Stack spacing={1} alignItems="center">
          <img
            src={extendedImages.subscribePage.satisfactionBanner}
            alt="satisfaction"
            style={{ maxWidth: '100%' }}
          />
          <Text variant="h4" color="text.secondary" align="center">
            SATISFACTION GUARANTEED
          </Text>
          <Text variant="body2" align="center">
            If you're dissatisfied with the results of your search,{' '}
            <strong>we will gladly help you out or offer a refund.</strong>
          </Text>
        </Stack>
      </SidebarCard>

      <SidebarCard>
        <Stack spacing={1} alignItems="center">
          <img src={extendedImages.subscribePage.nmvtisLogo} alt="nmvtis" />
          <Text variant="h4" color="text.secondary" align="center">
            APPROVED NMVTIS DATA PROVIDER
          </Text>
        </Stack>
      </SidebarCard>
    </>
  );
};
